query TropesQuery {
  tropes {
    name
    tropeLines {
      order
      text
    }
  }
}
